<template>
  <div class="container-fluid">
    <Breadcrumbs title="Solicitudes" main="Viajero" />
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Solicitudes de viajeros pendientes</h5>
        <button class="btn btn-outline-dark btn-sm" :disabled="loading" @click="load">
          Actualizar
        </button>
      </div>
      <div class="card-body">
        <div v-if="loading" class="text-center py-4 text-muted">Cargando solicitudes...</div>
        <div v-else-if="error" class="alert alert-danger">{{ error }}</div>
        <div v-else-if="!items.length" class="text-center py-4 text-muted">
          No hay solicitudes en revisión.
        </div>
        <div v-else class="row g-3">
          <div v-for="item in items" :key="item.id" class="col-12">
            <div class="border rounded p-3">
              <div class="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
                <div>
                  <h6 class="mb-1 fw-bold">{{ item.nombre || 'Sin nombre' }}</h6>
                  <div class="text-muted small">{{ item.email }}</div>
                  <div class="text-muted small">{{ item.phone || '—' }}</div>
                </div>
                <span class="badge bg-warning text-dark">En revisión</span>
              </div>

              <div class="row g-3 mb-3">
                <div class="col-md-4">
                  <label class="form-label text-muted small mb-1">Documento de identidad</label>
                  <a
                    v-if="item.identityDocumentUrl"
                    :href="item.identityDocumentUrl"
                    target="_blank"
                    rel="noopener"
                    class="d-block"
                  >
                    <img :src="item.identityDocumentUrl" alt="Identidad" class="img-fluid rounded border" />
                  </a>
                  <span v-else class="text-muted small">—</span>
                </div>
                <div class="col-md-4">
                  <label class="form-label text-muted small mb-1">DNI frente</label>
                  <a
                    v-if="item.dniFrontUrl"
                    :href="item.dniFrontUrl"
                    target="_blank"
                    rel="noopener"
                    class="d-block"
                  >
                    <img :src="item.dniFrontUrl" alt="DNI frente" class="img-fluid rounded border" />
                  </a>
                  <span v-else class="text-muted small">—</span>
                </div>
                <div class="col-md-4">
                  <label class="form-label text-muted small mb-1">DNI reverso</label>
                  <a
                    v-if="item.dniBackUrl"
                    :href="item.dniBackUrl"
                    target="_blank"
                    rel="noopener"
                    class="d-block"
                  >
                    <img :src="item.dniBackUrl" alt="DNI reverso" class="img-fluid rounded border" />
                  </a>
                  <span v-else class="text-muted small">—</span>
                </div>
              </div>

              <div class="row g-2 small mb-3">
                <div class="col-md-3"><span class="text-muted">RFC:</span> {{ item.rfc || '—' }}</div>
                <div class="col-md-3"><span class="text-muted">Razón social:</span> {{ item.razonSocial || '—' }}</div>
                <div class="col-md-3"><span class="text-muted">Dirección:</span> {{ item.direccion || '—' }}</div>
                <div class="col-md-3"><span class="text-muted">C.P.:</span> {{ item.codigoPostal || '—' }}</div>
              </div>

              <div class="d-flex gap-2">
                <button
                  class="btn btn-success btn-sm"
                  :disabled="actionId === item.id"
                  @click="approve(item)"
                >
                  Aprobar
                </button>
                <button
                  class="btn btn-outline-danger btn-sm"
                  :disabled="actionId === item.id"
                  @click="reject(item)"
                >
                  Rechazar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/layout/breadCrumbs.vue';
import { clientsApi } from '@/api/clients';

export default {
  name: 'SolicitudesViajero',
  components: { Breadcrumbs },
  data() {
    return {
      items: [],
      loading: false,
      error: null,
      actionId: null,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.error = null;
      try {
        const { data } = await clientsApi.listTravelerRequests();
        this.items = Array.isArray(data) ? data : [];
      } catch (e) {
        this.error = e?.response?.data?.message || 'No se pudieron cargar las solicitudes.';
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    async approve(item) {
      if (!item?.id) return;
      this.actionId = item.id;
      try {
        await clientsApi.approveTravelerRequest(item.id);
        await this.load();
      } catch (e) {
        this.error = e?.response?.data?.message || 'No se pudo aprobar la solicitud.';
      } finally {
        this.actionId = null;
      }
    },
    async reject(item) {
      if (!item?.id) return;
      if (!window.confirm('¿Rechazar esta solicitud de viajero?')) return;
      this.actionId = item.id;
      try {
        await clientsApi.rejectTravelerRequest(item.id);
        await this.load();
      } catch (e) {
        this.error = e?.response?.data?.message || 'No se pudo rechazar la solicitud.';
      } finally {
        this.actionId = null;
      }
    },
  },
};
</script>
